import {
  AccountMergeRequest,
  AccountMergeRequestStatus,
} from './AccountMergeRequest'
import { computed, makeObservable } from 'mobx'
import { Id } from '../../types/definitions'
import { match } from 'utils/pattern-match-util'
import { StatusOrActions } from './AccountMergeRequestSearchViewModel'
import { generateAvatarFallback } from '../../utils/image-util'

/**
 * Represents a specific account merge request item.
 */
export class AccountMergeRequestItemViewModel {
  constructor(
    private readonly _mergeRequest: AccountMergeRequest,
    private readonly _showingStatusOrActions: StatusOrActions,
    private readonly _hubspotPortalId: string,
  ) {
    makeObservable(this)
  }

  @computed
  get displayName() {
    return this._mergeRequest.displayName
  }

  @computed
  get avatar() {
    return this._mergeRequest.picture
  }

  @computed
  get avatarFallback() {
    return generateAvatarFallback(this.displayName)
  }

  @computed
  get email() {
    return this._mergeRequest.email
  }

  @computed
  get primaryAccountId() {
    return this._mergeRequest.primaryAccountId
  }

  @computed
  get duplicateAccountId() {
    return this._mergeRequest.duplicateAccountId
  }

  @computed
  get ticketId() {
    return this._mergeRequest.ticketId
  }

  @computed
  get displayStatus() {
    return match(this._mergeRequest.status, {
      [AccountMergeRequestStatus.Requested]: () => 'Merge requested',
      [AccountMergeRequestStatus.Rejected]: () => 'Request rejected',
      [AccountMergeRequestStatus.Linked]: () => 'Accounts merged',
      [AccountMergeRequestStatus.Ignored]: () => 'Request ignored',
    })
  }

  @computed
  get statusOrActions() {
    return this._showingStatusOrActions
  }

  @computed
  get dateCreated() {
    return this._mergeRequest.dateCreated
  }

  @computed
  get id() {
    return Id.assert(this._mergeRequest.id)
  }

  @computed
  get hubspotLink() {
    return `https://app.hubspot.com/contacts/${this._hubspotPortalId}/ticket/${this.ticketId}`
  }
}
